import { gql } from 'graphql-request';

export const createSupportRequest = gql`
    mutation createSupportRequest($input: SupportRequestInput!) {
        createSupportRequest(input: $input)
    }
`;

export type CreateSupportRequestQueryResult = boolean;

export const shareProjectAccessMutation = gql`
    mutation users($in: ShareProjectAccessInput!) {
        users {
            shareProjectAccess(in: $in)
        }
    }
`;
